import type { MileageChangeReason, VehicleAmendmentType } from '../types/vehicleRegistration.types';
import { labelForReason } from './registrationChangeLabels';

export const VEHICLE_AMENDMENT_TYPE_LABEL: Record<VehicleAmendmentType, string> = {
    registration: 'Registration',
    mileage: 'Mileage',
};

const AMENDMENT_FIELD_LABEL: Record<string, string> = {
    vrm: 'Registration',
    mileage: 'Mileage',
};

export const MILEAGE_CHANGE_REASON_LABEL: Record<MileageChangeReason, string> = {
    invoice_submitted: 'Invoice submitted',
    invoice_reversed: 'Invoice reversed',
};

const labelOrVerbatim = (labels: Record<string, string>, value: string): string =>
    Object.hasOwn(labels, value) ? labels[value] : value;

/** An unknown type, reason or field renders verbatim, so an amendment class this build
 *  has never seen is still legible in the log. */
export const labelForAmendmentType = (type: string): string => labelOrVerbatim(VEHICLE_AMENDMENT_TYPE_LABEL, type);

export const labelForAmendmentField = (field: string): string => labelOrVerbatim(AMENDMENT_FIELD_LABEL, field);

export const labelForAmendmentReason = (reason: string | null): string | undefined =>
    reason !== null && Object.hasOwn(MILEAGE_CHANGE_REASON_LABEL, reason)
        ? MILEAGE_CHANGE_REASON_LABEL[reason as MileageChangeReason]
        : labelForReason(reason);
